export const createErrorFromEvent = (event) => {
    if (typeof event === 'string') {
        return new Error(event);
    }
    if (event instanceof ErrorEvent) {
        return new Error(event.message);
    }
    if (event instanceof Event) {
        return new Error(`Unknown runtime error from event: ${event.type}`);
    }
    return new Error(`Unknown runtime error: ${JSON.stringify(event)}`);
};
//# sourceMappingURL=utils.js.map